import get from 'lodash.get';

const getPartnerBranding = (rootState) => get(rootState, 'partner.properties.wsBranding');

export default getPartnerBranding;
